define('OutSystems/ReactView/ScrollExtensions',["require", "exports", "@outsystems/virtualized-list"], function (require, exports, virtualized_list_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.loadScrollProperties = exports.serializeScrollProperties = exports.setScrollOffset = exports.getScrollInfo = exports.getScrollHostInfo = void 0;
    function getScrollHostInfo(element, excludeStaticParent) {
        return virtualized_list_1.ScrollExtensions.getScrollHostInfo(element.parentElement, excludeStaticParent);
    }
    exports.getScrollHostInfo = getScrollHostInfo;
    function getScrollInfo(scrollHost) {
        return virtualized_list_1.ScrollExtensions.getScrollInfo(scrollHost);
    }
    exports.getScrollInfo = getScrollInfo;
    function setScrollOffset(scrollHost, x, y) {
        virtualized_list_1.ScrollExtensions.setScrollOffset(scrollHost, x, y);
    }
    exports.setScrollOffset = setScrollOffset;
    function serializeScrollProperties(domNode) {
        var customProperties = {};
        if (!domNode) {
            return customProperties;
        }
        var scrollLeft = domNode.scrollLeft;
        var scrollTop = domNode.scrollTop;
        if (!!scrollLeft) {
            customProperties.scrollLeft = scrollLeft;
        }
        if (!!scrollTop) {
            customProperties.scrollTop = scrollTop;
        }
        return customProperties;
    }
    exports.serializeScrollProperties = serializeScrollProperties;
    function loadScrollProperties(domNode, customProperties) {
        if (!domNode) {
            return;
        }
        if (!!customProperties.scrollLeft) {
            domNode.scrollLeft = customProperties.scrollLeft;
        }
        if (!!customProperties.scrollTop) {
            domNode.scrollTop = customProperties.scrollTop;
        }
    }
    exports.loadScrollProperties = loadScrollProperties;
});
//# sourceMappingURL=ScrollExtensions.js.map;
